import * as React from "react";
import { useQueryParam } from "use-query-params";
import { blogUrl } from "../../core/paths";
import { PageCategory, Post, Tag } from "../../core/types";
import { SearchResultPage } from "./SearchResultPage";
import { HomePage } from "./HomePage";

interface IProps {
  pageContext: {
    pageInfo: {
      title: string;
      slug: string;
    };
    currentCategory?: PageCategory;
    pageNumber: number;
    categories: PageCategory[];
    postsByCategory: {};
    featuredPosts: Post[];
    firstFeaturedCategoryId: string;
    secondFeaturedCategoryId: string;
    tags: Tag[];
  };
}

const SearchQuery = {
  encode(value) {
    return value;
  },
  decode(value) {
    return value;
  },
};

const View = ({ pageContext }: IProps) => {
  // const { postsByCategory, currentCategory, categories, tags, ...rest } =
  //   pageContext;
  // const [searchQuery] = useQueryParam("search", SearchQuery);

  return <HomePage {...pageContext} />
};

export default View;
